import * as React from 'react';
import {RouteProps, RouteComponentProps} from 'react-router';
import {BaseRoute} from '@mintdata-wsp/wsp/ui/routes/BaseRoute';

export interface IPublicRouteProps extends RouteProps
{
    page:React.ComponentClass;
}

export class PublicRoute extends React.Component<IPublicRouteProps, any>
{
    public render()
    {
        return <BaseRoute {...this.props} renderRoute={this._renderRoute} />;
    }

    private _renderRoute = (routeComponentProps:RouteComponentProps<any>):JSX.Element =>
    {
        const Page:any = this.props.page;

        return <Page {...routeComponentProps} />;
    };
}
